export default class SupportCheckField {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.modalBox = document.getElementById(
      'support_checkprofiles-modal-container'
    );
    this.blogFields = ['Blogtitel', 'Blogheadline', 'Blogkommentar'];
    this.gallFields = ['Gal. Titel', 'Gal. Beschreibung', 'Gal. Kommentar'];
    this.gbFields = ['Gästebuch'];
    this.autoreplayFields = ['Autoreply'];
    this.hits = this.el.querySelectorAll('.modal-link');
    this.saveFieldOperations();
  }

  getModalData() {
    this.modalId = this.el.getAttribute('data-modal-id');
    this.modal = document.querySelector(this.modalId);
    this.modalField = {
      fieldName: this.modal.querySelector('#fieldname'),
      userid: this.modal.querySelector('#userid'),
      profileId: this.modal.querySelector('#profileId'),
      profileUserid: this.modal.querySelector('#profileUserid'),
      warnings: this.modal.querySelector('#warnings'),
      gid: this.modal.querySelector('#gid'),
      warn: this.modal.querySelector('#warn')
    };
    /* eslint-disable no-unused-vars */
    this.greenWarning = this.el.getAttribute('data-greenWarning');
    this.yellowWarning = this.el.getAttribute('data-yellowWarning');
    this.orangeWarning = this.el.getAttribute('data-orangeWarning');
    this.redWarning = this.el.getAttribute('data-redWarning');
    this.redWarning2 = this.el.getAttribute('data-redWarning2');
    this.deleteWarning = this.el.getAttribute('data-deleteWarning');
    /* eslint-enable no-unused-vars */
    this.closeButton = this.modal.querySelector('.close');
  }

  saveNoSingleField(tLink) {
    const gid = tLink.getAttribute('data-gid');
    const payflag = tLink.getAttribute('data-premium');
    // Fill hidden field s
    this.modalField.userid.value = tLink.getAttribute('data-userid');
    this.modalField.profileId.value = tLink.getAttribute('data-profileId');
    this.modalField.profileUserid.value = tLink.getAttribute(
      'data-profileUserid'
    );
    this.modalField.warnings.value = parseInt(
      tLink.getAttribute('data-warnings'),
      10
    );
    this.modalField.warn.value = parseInt(tLink.getAttribute('data-warn'), 10);
    // Info fields
    if (payflag) {
      document.getElementById('isPremium').style.display = 'block';
    }
    // Content field
    const rawTxtId = `#clearText_${gid}`;
    const rawTxt = this.el.querySelector(rawTxtId);
    const contentField = this.modal.querySelector('#contentField');
    contentField.value = rawTxt.innerHTML;
    // Warnings etc
    let warnText = '';
    const warningsValue = parseInt(this.modalField.warnings.value, 10);
    if (warningsValue === 0) {
      warnText = this.yellowWarning;
    } else if (warningsValue === 1) {
      warnText = this.orangeWarning;
    } else if (warningsValue === 2) {
      warnText = this.redWarning2;
    } else if (warningsValue === 3) {
      warnText = this.deleteWarning;
    }
    const textWarn = document.getElementById('textWarn');
    if (warnText !== '') {
      textWarn.style.display = 'block';
      const warnBox = textWarn.querySelectorAll('P');
      warnBox[1].innerHTML = warnText;
    }
    // Submit data
    const data = {};
    data.json = true;
    let mode = '';
    let modul = '';
    let method = '';
    switch (this.fieldToCheck) {
      case 'Autoreply':
        mode = 'saveAutoreply';
        modul = 'a';
        method = 'POST';
        data.str = 'ar';
        break;
      case 'Blogtitel':
        mode = 'saveBlogTitle';
        modul = 'a';
        method = 'POST';
        data.id = gid;
        data.profileId = tLink.getAttribute('data-userid');
        data.adduser = contentField.value;
        data.str = 0;
        break;
      case 'Blogheadline':
        mode = 'editBlogText';
        modul = 'a';
        method = 'POST';
        data.id = gid;
        data.profileId = tLink.getAttribute('data-userid');
        data.adduser = contentField.value;
        data.str = 0;
        break;
      case 'Blogkommentar':
        mode = 'editBlogEntry';
        modul = 'a';
        method = 'POST';
        data.id = gid;
        data.str = 'ar';
        break;
      case 'Gästebuch':
        mode = 'editGB';
        modul = 'sae';
        method = 'POST';
        data.adduser = contentField.value;
        data.id = gid;
        data.str = 0;
        break;
      case 'Gal. Titel':
        mode = 'editGalTitle';
        modul = 'sae';
        method = 'POST';
        data.id = gid;
        data._ = 1543361619970;
        data.str = 0;
        break;
      case 'Gal. Beschreibung':
        mode = 'editGalDesc';
        modul = 'sae';
        method = 'POST';
        data.id = gid;
        data._ = 1543361619970;
        data.str = 0;
        break;
      case 'Gal. Kommentar':
        mode = 'editGalComm';
        modul = 'sae';
        method = 'POST';
        data.id = gid;
        data.str = 0;
        break;
      // no default
    }
    data.mode = mode;
    const URL = `${window.location.protocol}//${window.location.hostname}`;
    const ajaxURL =
      modul === 'sae' ? `${URL}/support/ajax_edit.php` : `${URL}/ajax.php`;
    $('body').on('click', '#savebutton', e => {
      e.preventDefault();
      data.text = contentField.value;
      if (data.str === 'ar') {
        data.profileId = tLink.getAttribute('data-userid');
        data.adduser = `profileId=${data.profileId}&`;
        data.adduser = `${data.adduser}flag=1&`;
        data.adduser = `${data.adduser}force=1&`;
        data.adduser = `${data.adduser}warnings=${this.modalField.warnings.value}&`;
        data.adduser = `${data.adduser}warn=${this.modalField.warn.value}&`;
        data.adduser = `${data.adduser}autoreply_text=${contentField.value}`;
      } else {
        data.adduser = contentField.value;
      }
      $.ajax({
        url: ajaxURL,
        method: method === 'POST' ? 'POST' : 'GET',
        type: 'json',
        data,
        success: () => {
          this.closeButton.click();
          window.location.reload(true);
          // window.location = window.location.href;
        }
      });
    });
    $('body').on('click', '#savewarnbutton', e => {
      e.preventDefault();
      data.text = contentField.value;
      if (data.str === 'ar') {
        data.profileId = tLink.getAttribute('data-userid');
        // data.warnings = this.modalField.warnings.value;
        // data.warn = this.modalField.warn.value;
        data.adduser = `profileId=${data.profileId}&`;
        data.adduser = `${data.adduser}flag=1&`;
        data.adduser = `${data.adduser}force=1&`;
        data.adduser = `${data.adduser}warnings=${this.modalField.warnings.value}&`;
        data.adduser = `${data.adduser}warn=${this.modalField.warn.value}&`;
        data.adduser = `${data.adduser}autoreply_text=${contentField.value}`;
      } else {
        data.adduser = contentField.value;
      }
      $.ajax({
        url: ajaxURL,
        method: 'POST',
        type: 'json',
        data,
        success: () => {
          this._sendWarn(this.closeButton, this.modalField);
        }
      });
    });
  }

  saveSingleField(tLink) {
    // Data
    const mLink = tLink;
    const gid = mLink.getAttribute('data-gid');
    const payflag = mLink.getAttribute('data-premium');

    // Fill hidden field s
    this.modalField.userid.value = mLink.getAttribute('data-userid');
    this.modalField.profileId.value = mLink.getAttribute('data-profileId');
    this.modalField.profileUserid.value = mLink.getAttribute(
      'data-profileUserid'
    );
    this.modalField.warnings.value = parseInt(
      mLink.getAttribute('data-warnings'),
      10
    );
    this.modalField.warn.value = parseInt(mLink.getAttribute('data-warn'), 10);
    // Info fields
    if (payflag) {
      document.getElementById('isPremium').style.display = 'block';
    }
    // Content field
    const rawTxtId = `#clearText_${gid}`;
    const rawTxt = this.el.querySelector(rawTxtId);
    const contentField = this.modal.querySelector('#contentField');
    contentField.value = rawTxt.innerHTML;
    // Warnings etc
    let warnText = '';
    const warningsValue = parseInt(this.modalField.warnings.value, 10);
    if (warningsValue === 0) {
      warnText = this.yellowWarning;
    } else if (warningsValue === 1) {
      warnText = this.orangeWarning;
    } else if (warningsValue === 2) {
      warnText = this.redWarning2;
    } else if (warningsValue === 3) {
      warnText = this.deleteWarning;
    }
    const textWarn = document.getElementById('textWarn');
    if (warnText !== '') {
      textWarn.style.display = 'block';
      const warnBox = textWarn.querySelectorAll('P');
      warnBox[1].innerHTML = warnText;
    }
    // Submit data
    const URL = `${window.location.protocol}//${window.location.hostname}`;
    const ajaxURL = `${URL}/ajax.php`;
    const data = {};
    $('body').on('click', '#savebutton', e => {
      e.preventDefault();
      data.adduser = contentField.value;
      data.text = contentField.value;
      data.field = this.modalField.fieldName.value;
      data.mode = 'saveSinglePfield';
      data.profileId = this.modalField.userid.value;
      $.ajax({
        url: ajaxURL,
        method: 'POST',
        type: 'json',
        data,
        success: () => {
          this.closeButton.click();
          window.location = window.location.href;
        }
      });
    });
    $('body').on('click', '#savewarnbutton', e => {
      e.preventDefault();
      data.adduser = contentField.value;
      data.field = this.modalField.fieldName.value;
      data.mode = 'saveSinglePfield';
      data.profileId = this.modalField.userid.value;
      data.id = this.modalField.userid.value;
      data.json = true;
      data.warn = this.modalField.warn.value;
      data.warnings = this.modalField.warnings.value;
      data.info = ajaxURL;
      $.ajax({
        url: ajaxURL,
        method: 'POST',
        type: 'json',
        data,
        success: () => {
          this._sendWarn(this.closeButton, this.modalField);
        }
      });
    });
  }

  saveFieldOperations() {
    this.getModalData();
    $('body').on('click', '#close-modal-dialog', () => {
      this._resetButtons();
    });
    this.hits.forEach(link => {
      link.addEventListener('click', currLink => {
        // Modal
        const tLink =
          currLink.target.localName === 'div'
            ? currLink.target
            : currLink.target.parentNode;
        this.fieldToCheck = this.el.getAttribute('data-check');
        if (
          this.blogFields.includes(this.fieldToCheck) ||
          this.gallFields.includes(this.fieldToCheck) ||
          this.gbFields.includes(this.fieldToCheck) ||
          this.autoreplayFields.includes(this.fieldToCheck)
        ) {
          this.saveNoSingleField(tLink);
        } else {
          this.saveSingleField(tLink);
        }
      });
    });
  }

  _resetButtons() {
    $('body').off('click', '#savebutton');
    $('body').off('click', '#savewarnbutton');
  }

  _sendWarn(closeButton, modalField) {
    // eslint-disable no-unused-vars
    const data2 = {};
    data2.profileId = modalField.userid.value;
    data2.id = modalField.userid.value;
    data2.json = true;
    data2.mode = 'sendWarning';
    data2.warn = modalField.warn.value;
    data2.warnings = modalField.warnings.value;
    $.ajax({
      url: '/support/ajax_edit.php',
      method: 'GET',
      type: 'json',
      data: data2,
      success: () => {
        closeButton.click();
        window.location = window.location.href;
      }
    });
    // eslint-enable no-unused-vars
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/support_check_field.js